import React, { useEffect, useState, useMemo } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Select from 'react-select';


function LabReports() {
  const localToday = (() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  })();

  // helpers
  function mapPayMode(raw) {
    if (!raw) return '';
    const s = String(raw).trim().toLowerCase();
    if (s.includes('cash')) return 'Cash';
    if (s.includes('card') || s.includes('credit') || s.includes('debit') || s.includes('swipe')) return 'Card';
    if (s.includes('online') || s.includes('upi') || s.includes('gateway') || s.includes('net')) return 'Online';
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  }
  
  function classifyMode(raw) {
    if (!raw) return '';
    const s = String(raw).toLowerCase();
    if (s.includes('cash')) return 'cash';
    if (s.includes('card') || s.includes('credit') || s.includes('debit') || s.includes('swipe')) return 'card';
    if (s.includes('online') || s.includes('upi') || s.includes('gateway') || s.includes('net')) return 'online';
    return '';
  }

  function parseServerDate(datetimeStr) {
    if (!datetimeStr) return null;
    const cleaned = String(datetimeStr).replace('T', ' ').trim();
    const [datePart, timePart] = cleaned.split(' ');
    const [year, month, day] = (datePart || '').split('-').map(n => parseInt(n, 10));
    if (!year || !month || !day) return null;
    let hours = 0, minutes = 0, seconds = 0;
    if (timePart) {
      const parts = timePart.split(':').map(n => parseInt(n, 10));
      hours = Number.isFinite(parts[0]) ? parts[0] : 0;
      minutes = Number.isFinite(parts[1]) ? parts[1] : 0;
      seconds = Number.isFinite(parts[2]) ? parts[2] : 0;
    }
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  function toLocalYMD(dateObj) {
    if (!dateObj) return '';
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function formatDateTime12h(dateObj) {
    if (!dateObj) return '';
    const day = String(dateObj.getDate()).padStart(2, '0');
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const month = monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; hours = hours === 0 ? 12 : hours;
    const hourStr = String(hours).padStart(2, '0');
    return `${day} ${month}- ${year} ${hourStr}:${minutes} ${ampm}`;
  }

  // ✅ Helper to get test price from multiple possible fields
  const getTestPrice = (test) => {
    return Number(
      test.lab_item_price || 
      test.lab_item_amt || 
      test.lab_item_total || 
      test.test_price || 
      0
    );
  };

  // ── react-select custom styles to match Bootstrap ──
  const reactSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13,110,253,.25)' : 'none',
      '&:hover': { borderColor: '#86b7fe' },
      fontSize: '14px',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#e7f1ff',
      borderRadius: '4px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#0d6efd',
      fontSize: '13px',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#0d6efd',
      ':hover': { backgroundColor: '#0d6efd', color: 'white' },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#6c757d',
      fontSize: '14px',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '14px',
      backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e7f1ff' : 'white',
      color: state.isSelected ? 'white' : '#212529',
    }),
  };

  // state
  const [summary, setSummary] = useState({
    totalReports: 0, totalAmount: 0, todaysCollection: 0, collectionBy: { cash: 0, online: 0, card: 0 }
  });

  const [totals, setTotals] = useState({
    totalCharges: "0.00",
    finalAmount: "0.00",
    newPaid: "0.00",
    laterPaid: "0.00",
    totalPaid: "0.00",
    discountAmount: "0.00",
    totalDue: "0.00",
    totalRows: 0,
    cashTotal: "0.00",
    cardTotal: "0.00",
    onlineTotal: "0.00"
  });

  const [testDepartments, setTestDepartments] = useState([]);
  const [selectedTestDepts, setSelectedTestDepts] = useState([]);       // ← multiselect
  const [filteredTests, setFilteredTests] = useState([]);

  const [masterList, setMasterList] = useState([]);
  const [paymentsList, setPaymentsList] = useState([]);
  const [paymentTransactions, setPaymentTransactions] = useState([]);
  const [transactionTotals, setTransactionTotals] = useState({
    cash: 0, card: 0, online: 0, total: 0
  });
  const [allTests, setAllTests] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState({});
  const [formData, setFormData] = useState({
    docs: [],
    l1: [],
    departs: [],
    search_key: '',
    from: localToday,
    to: localToday,
    lab_reg_referral_user_ids: [],   // ← multiselect (was singular)
    lab_reg_referral: "",
    selectedDepartments: [],         // ← multiselect (was singular)
    selectedTests: [],               // ← multiselect (was singular)
    selectedUserIds: []              // ← multiselect (was singular)
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  const loadTestDepartments = async () => {
    try {
      const fd = new FormData();
      fd.append("search_key", "");
      const res = await axios.post(AppConst.BASE_URL + AppConst.getTestDepartmentsUrl, fd);
      if (res.data.status) {
        setTestDepartments(res.data.records || []);
      }
    } catch (e) {
      console.error("Failed to load test departments", e);
    }
  };

  // ── react-select option builders ──
  const doctorOptions = useMemo(() =>
    (formData.docs || []).map(doc => ({
      value: String(doc.user_id),
      label: doc.fname || doc.name || doc.user_id || ''
    })),
    [formData.docs]
  );

  const testDeptOptions = useMemo(() =>
    testDepartments.map(td => ({
      value: String(td.test_dept_id),
      label: td.test_dept_name || ''
    })),
    [testDepartments]
  );

  const testOptions = useMemo(() =>
    filteredTests.map(t => ({
      value: t.test_name,
      label: t.test_name
    })),
    [filteredTests]
  );

  const userOptions = useMemo(() =>
    usersList.map(u => ({
      value: String(u.user_id),
      label: u.name
    })),
    [usersList]
  );

  // ✅ FIXED: groupByUHID - properly sum filtered test amounts
  const groupByUHID = (records) => {
    const grouped = {};
    records.forEach(item => {
      const uhid = item.lab_reg_uhid || ('UHID_' + (item.lab_reg_id || Math.random()));

      if (!grouped[uhid]) {
        grouped[uhid] = {
          lab_reg_id: item.lab_reg_id,
          lab_reg_uhid: item.lab_reg_uhid,
          lab_reg_name_title: item.lab_reg_name_title,
          lab_reg_name: item.lab_reg_name,
          lab_reg_mobile: item.lab_reg_mobile,
          lab_reg_referral: item.lab_reg_referral,
          lab_reg_user: item.lab_reg_user,
          last_used: item.last_used || item.fname || '',
          last_used_id: item.last_used_id || item.user_id || item.lab_reg_user || '',
          fname: item.fname || '',
          lab_reg_datetime: item.lab_reg_datetime || item.lab_reg_date || '',
          total_final_amt: Number(item.lab_final_amt || item.lab_total || 0),
          total_paid: Number(item.lab_paid || 0),
          total_due: Number(item.lab_due || 0),
          tests: item.tests && item.tests.length > 0 ? item.tests.map(t => ({ 
            lab_item_test_name: t.lab_item_test_name || t.test_name || '',
            lab_item_price: getTestPrice(t),
            test_price: getTestPrice(t)
          })) : [],
          department_ids: (item.params || []).map(p => p.test_cat).filter(Boolean),
          cash_amount: Number(item.paid_cash || 0),
          card_amount: Number(item.paid_card || 0),
          online_amount: Number(item.paid_online || 0),
          __firstRow: item
        };
      } else {
        const newTests = (item.tests || []).map(t => ({ 
          lab_item_test_name: t.lab_item_test_name || t.test_name || '',
          lab_item_price: getTestPrice(t),
          test_price: getTestPrice(t)
        }));
        grouped[uhid].tests.push(...newTests);
        
        (item.params || []).forEach(p => {
          if (p && p.test_cat && !grouped[uhid].department_ids.includes(p.test_cat)) {
            grouped[uhid].department_ids.push(p.test_cat);
          }
        });
        
        grouped[uhid].total_final_amt += Number(item.lab_final_amt || item.lab_total || 0);
        grouped[uhid].total_paid += Number(item.lab_paid || 0);
        grouped[uhid].total_due += Number(item.lab_due || 0);

        const prevDt = parseServerDate(grouped[uhid].lab_reg_datetime || '');
        const thisDt = parseServerDate(item.lab_reg_datetime || item.lab_reg_date || '');
        if (thisDt && (!prevDt || thisDt.getTime() > prevDt.getTime())) {
          grouped[uhid].lab_reg_datetime = item.lab_reg_datetime || item.lab_reg_date || grouped[uhid].lab_reg_datetime;
        }

        grouped[uhid].cash_amount += Number(item.paid_cash || 0);
        grouped[uhid].card_amount += Number(item.paid_card || 0);
        grouped[uhid].online_amount += Number(item.paid_online || 0);

        if (!grouped[uhid].last_used && (item.last_used || item.fname)) {
          grouped[uhid].last_used = item.last_used || item.fname || grouped[uhid].last_used;
          grouped[uhid].last_used_id = item.last_used_id || item.user_id || item.lab_reg_user || grouped[uhid].last_used_id;
        }
      }
    });
    return Object.values(grouped);
  };
  const [categories, setCategories] = useState([]);

  const loadCategories = async () => {
    try {
      const fd = new FormData();
      fd.append('cat_type', 'department');   // ✅ same as Departments page
      fd.append('page_no', 'none');
      fd.append('search_key', '');
      fd.append('par_by', '1');
      const res = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.status && Array.isArray(res.data.records)) {
        setCategories(res.data.records);
      }
    } catch (e) {
      console.error('loadCategories failed', e);
    }
  };
  
  useEffect(() => { loadCategories(); }, []);
  const handleDoctorApprove = async (labRegId, uhid) => {
    try {
      const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
      if (!storedDataF.user_id) {
        toast.error("User not logged in");
        return;
      }

      const fd = new FormData();
      fd.append('lab_reg_id', labRegId);
      fd.append('approved_by', storedDataF.user_id);
      fd.append('approved_by_name', storedDataF.fname || storedDataF.username || 'Doctor');
      fd.append('approval_datetime', new Date().toISOString().slice(0, 19).replace('T', ' '));

      const response = await axios.post(AppConst.BASE_URL + AppConst.approveLabReportUrl, fd);
      
      if (response.data && response.data.status) {
        setApprovalStatus(prev => ({
          ...prev,
          [labRegId]: {
            approved: true,
            approved_by: storedDataF.fname || storedDataF.username || 'Doctor',
            approved_datetime: new Date().toLocaleString()
          }
        }));
        toast.success(`Report ${uhid} approved successfully`);
      } else {
        toast.error(response.data?.success || "Failed to approve report");
      }
    } catch (error) {
      console.error("Approval error:", error);
      toast.error("Failed to approve report");
    }
  };

  // main fetch + logic
  const initData = async () => {
    const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    if (!storedDataF.user_id) {
      console.warn("No user in sessionStorage (ldata). Aborting fetch.");
      return;
    }

    try {
      const fd = new FormData();
      fd.append('search_key', formData.search_key || "");
      fd.append('from', formData.from ? `${formData.from} 00:00:00` : "");
      fd.append('to', formData.to ? `${formData.to} 23:59:59` : "");

      // ✅ Send multiple doctor IDs if selected
    // ✅ Send doctor names for referral filter
if (formData.lab_reg_referral_user_ids && formData.lab_reg_referral_user_ids.length > 0) {
  const selectedDocs = (formData.docs || []).filter(doc =>
    formData.lab_reg_referral_user_ids.includes(String(doc.user_id))
  );
  selectedDocs.forEach(doc => {
    const name = doc.fname || doc.name || '';
    if (name.trim()) {
      fd.append('lab_reg_referral_names[]', name.trim());
    }
  });
}

      // ✅ Send multiple user IDs if selected
      if (formData.selectedUserIds && formData.selectedUserIds.length > 0) {
        formData.selectedUserIds.forEach(id => {
          fd.append('lab_reg_user', String(id));
        });
      }

      fd.append('page_no', 'none');

      // optional items call
      try {
        const resItm = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd);
        if (resItm.data && resItm.data.status && Array.isArray(resItm.data.records)) {
          setFormData(prev => ({ ...prev, l1: resItm.data.records }));
        } else {
          setFormData(prev => ({ ...prev, l1: [] }));
        }
      } catch (e) {
        console.warn("getLabRegListItmUrl failed:", e);
        setFormData(prev => ({ ...prev, l1: [] }));
      }

      const res = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListUrl, fd);
      if (res.data && res.data.status && Array.isArray(res.data.records)) {
        const records = res.data.records;
        setMasterList(records);

        // users
        const uMap = {};
        records.forEach(r => {
          const uid = r.last_used_id ?? r.lab_reg_user ?? r.user_id ?? null;
          const uname = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || (`User #${uid}`);
          if (uid) uMap[uid] = uname;
        });
        setUsersList(Object.keys(uMap).map(uid => ({ user_id: uid, name: uMap[uid] })));

        // fallback docs if none in formData.docs
        if (!formData.docs || formData.docs.length === 0) {
          const docMap = {};
          records.forEach(r => {
            if (r.type === 'doctor' || r.role_id === 'doctor') {
              const id = r.user_id || r.last_used_id || ('doc_' + (r.fname || r.lab_reg_referral || 'unknown'));
              docMap[id] = { user_id: id, fname: r.fname || r.last_used || r.lab_reg_referral || '' };
            } else if (r.lab_reg_referral && r.lab_reg_referral.trim() !== '') {
              const id = 'ref_' + r.lab_reg_referral;
              docMap[id] = { user_id: id, fname: r.lab_reg_referral };
            }
          });
          setFormData(prev => {
            // Only set fallback docs if the real doctor list hasn't loaded yet
            if (prev.docs && prev.docs.length > 0) return prev;
            
            const docMap = {};
            records.forEach(r => {
              if (r.type === 'doctor' || r.role_id === 'doctor') {
                const id = r.user_id || r.last_used_id || ('doc_' + (r.fname || r.lab_reg_referral || 'unknown'));
                docMap[id] = { user_id: id, fname: r.fname || r.last_used || r.lab_reg_referral || '' };
              } else if (r.lab_reg_referral && r.lab_reg_referral.trim() !== '') {
                const id = 'ref_' + r.lab_reg_referral;
                docMap[id] = { user_id: id, fname: r.lab_reg_referral };
              }
            });
            return { ...prev, docs: Object.values(docMap) };
          });
        }

        // summary/today's collection
        let totalReports = records.length;
        let totalAmount = 0;
        let todaysCollection = 0;
        let cashToday = 0, cardToday = 0, onlineToday = 0;
        const localTodayYMD = localToday;

        records.forEach(item => {
          totalAmount += Number(item.lab_final_amt ?? item.lab_total ?? 0);

          const regDt = parseServerDate(item.lab_reg_datetime || item.lab_reg_date || '');
          const localYmd = regDt ? toLocalYMD(regDt) : '';

          if (localYmd === localTodayYMD) {
            const paid = Number(item.lab_paid || 0);
            if (paid > 0) {
              todaysCollection += paid;
              const mode = classifyMode(item.lab_pay_mode || '');
              if (mode === 'cash') cashToday += paid;
              else if (mode === 'card') cardToday += paid;
              else if (mode === 'online') onlineToday += paid;
            }
          }

          if (item.lab_due_pay_date) {
            const dueDt = parseServerDate(item.lab_due_pay_date);
            const dueYmd = dueDt ? toLocalYMD(dueDt) : '';
            if (dueYmd === localTodayYMD) {
              const duePaid = Number(item.lab_due_pay_amount || 0);
              if (duePaid > 0) {
                todaysCollection += duePaid;
                const mode = classifyMode(item.lab_due_pay_mode || '');
                if (mode === 'cash') cashToday += duePaid;
                else if (mode === 'card') cardToday += duePaid;
                else if (mode === 'online') onlineToday += duePaid;
              }
            }
          }
        });

        setSummary({
          totalReports,
          totalAmount,
          todaysCollection,
          collectionBy: { cash: cashToday, online: onlineToday, card: cardToday }
        });

        // unique tests
        const uniqueTests = [
          ...new Set(records.flatMap(r => (r.tests || []).map(t => (t.lab_item_test_name || t.test_name || '').trim())).filter(Boolean))
        ];
        setAllTests(uniqueTests.map(n => ({ test_name: n })));

        // BUILD payments list
        const userDisplayMap = {};
        records.forEach(r => {
          const uid = r.last_used_id ?? r.lab_reg_user ?? r.user_id ?? null;
          if (uid) userDisplayMap[String(uid)] = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || (`User #${uid}`);
        });

        const payments = records
          .filter(r => Number(r.lab_due_pay_amount || 0) > 0 && r.lab_due_pay_date)
          .map(r => {
            const rawUser = r.lab_due_pay_user ?? r.last_used ?? r.fname ?? '';
            let userName = rawUser;
            if (String(rawUser).match(/^\d+$/) && userDisplayMap[String(rawUser)]) {
              userName = userDisplayMap[String(rawUser)];
            } else if (userDisplayMap[String(r.last_used_id)]) {
              userName = userDisplayMap[String(r.last_used_id)];
            } else if (r.fname) {
              userName = r.fname;
            }
            return {
              lab_reg_id: r.lab_reg_id,
              lab_reg_uhid: r.lab_reg_uhid,
              lab_reg_name: r.lab_reg_name,
              lab_due_pay_mode: r.lab_due_pay_mode || '',
              lab_due_pay_date: r.lab_due_pay_date || '',
              lab_due_pay_amount: Number(r.lab_due_pay_amount || 0),
              lab_due_pay_user: rawUser,
              lab_due_pay_user_name: userName,
              __sourceRow: r
            };
          });

        const fromDate = formData.from ? new Date(`${formData.from}T00:00:00`) : null;
        const toDate = formData.to ? new Date(`${formData.to}T23:59:59`) : null;

        const paymentsFiltered = payments.filter(p => {
          if (!p.lab_due_pay_date) return false;
          const pd = parseServerDate(p.lab_due_pay_date);
          if (!pd) return false;
          if (fromDate && pd < fromDate) return false;
          if (toDate && pd > toDate) return false;
          return true;
        });

        setPaymentsList(paymentsFiltered);

        // Fetch payment transactions
        try {
          const txnFd = new FormData();
          txnFd.append('from', formData.from ? `${formData.from} 00:00:00` : "");
          txnFd.append('to', formData.to ? `${formData.to} 23:59:59` : "");
          
          const txnRes = await axios.post(AppConst.BASE_URL + AppConst.getPaymentTransactionsUrl, txnFd);
          
          if (txnRes.data && txnRes.data.status) {
            setPaymentTransactions(Array.isArray(txnRes.data.records) ? txnRes.data.records : []);
            setTransactionTotals(txnRes.data.totals || { cash: 0, card: 0, online: 0, total: 0 });
          } else {
            setPaymentTransactions([]);
            setTransactionTotals({ cash: 0, card: 0, online: 0, total: 0 });
          }
        } catch (e) {
          console.warn("getPaymentTransactionsUrl failed:", e);
          setPaymentTransactions([]);
          setTransactionTotals({ cash: 0, card: 0, online: 0, total: 0 });
        }

      } else {
        setMasterList([]);
        setUsersList([]);
        setPaymentsList([]);
        setPaymentTransactions([]);
        setTransactionTotals({ cash: 0, card: 0, online: 0, total: 0 });
        setSummary(prev => ({ ...prev, totalReports: 0, todaysCollection: 0, collectionBy: { cash:0, online:0, card:0 } }));
      }
    } catch (err) {
      console.error("initData error:", err);
      toast.error("Failed to fetch report data.");
    }
  };

  useEffect(() => {
    loadTestDepartments();
  }, []);
  
  useEffect(() => {
    const fetchMeta = async () => {
      try {
        try {
          const fd2 = new FormData();
          fd2.append('type', "doctor");
          fd2.append('page_no', "none");
          const docResponse = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd2);
          if (docResponse.data && docResponse.data.status && Array.isArray(docResponse.data.records) && docResponse.data.records.length > 0) {
            setFormData(prev => ({ ...prev, docs: docResponse.data.records }));
          }
        } catch (e) { console.warn("fetch doctors failed", e); }
        try {
          const fd3 = new FormData();
          fd3.append('cat_type', "department");
          fd3.append('page_no', "none");
          const deptResponse = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd3);
          if (deptResponse.data && deptResponse.data.status && Array.isArray(deptResponse.data.records)) {
            setFormData(prev => ({ ...prev, departs: deptResponse.data.records }));
          }
        } catch (e) { console.warn("fetch departments failed", e); }
      } finally {
        await initData();
      }
    };
    fetchMeta();
    // eslint-disable-next-line
  }, []);

  // debounce re-fetch on filter changes
  useEffect(() => {
    const t = setTimeout(() => initData(), 180);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [
    formData.from, formData.to,
    formData.lab_reg_referral_user_ids,
    formData.selectedDepartments,
    formData.selectedTests,
    formData.search_key,
    formData.selectedUserIds
  ]);

  useEffect(() => {
    if (!selectedTestDepts || selectedTestDepts.length === 0) {
      setFilteredTests(allTests);
      return;
    }

    const deptIds = selectedTestDepts.map(d => String(d.value));
    const tests = masterList.flatMap(r => r.params || [])
      .filter(p => deptIds.includes(String(p.test_department)))
      .map(p => ({
        test_name: p.test_name,
        test_department: p.test_department
      }));

    const unique = [
      ...new Map(tests.map(t => [t.test_name, t])).values()
    ];

    setFilteredTests(unique);
  }, [selectedTestDepts, masterList, allTests]);

  // ✅ FIXED: filterByTestDepartment - supports multiple departments
  const filterByTestDepartment = (records, testDeptSelections) => {
    if (!testDeptSelections || testDeptSelections.length === 0) return records;

    const deptIds = testDeptSelections.map(d => String(d.value));

    return records
      .map(rec => {
        const params = rec.params || [];

        const matchedTests = params.filter(
          p => deptIds.includes(String(p.test_department))
        );

        if (matchedTests.length === 0) return null;

        const testTotal = matchedTests.reduce(
          (sum, t) => sum + getTestPrice(t), 0
        );

        const originalTotal = Number(rec.lab_total || rec.lab_final_amt || 0);
        const ratio = originalTotal > 0 ? testTotal / originalTotal : 1;

        const paidAmount = Number(rec.lab_paid || 0) * ratio;
        const cashAmount = Number(rec.paid_cash || 0) * ratio;
        const cardAmount = Number(rec.paid_card || 0) * ratio;
        const onlineAmount = Number(rec.paid_online || 0) * ratio;

        return {
          ...rec,
          params: matchedTests,
          tests: matchedTests,
          lab_total: testTotal,
          lab_final_amt: testTotal,
          lab_paid: Math.min(paidAmount, testTotal),
          lab_due: Math.max(testTotal - paidAmount, 0),
          paid_cash: cashAmount,
          paid_card: cardAmount,
          paid_online: onlineAmount,
        };
      })
      .filter(Boolean);
  };
  
  const filteredList = useMemo(() => {
    let filteredData = [...masterList];

    // ✅ Multi-department filter
    if (formData.selectedDepartments && formData.selectedDepartments.length > 0) {
      const selIds = formData.selectedDepartments.map(d => String(d.value));
      filteredData = filteredData.filter(item => {
        const params = item.params || [];
        const matchesById = params.some(p => selIds.includes(String(p.test_cat)));
        const matchesByName = params.some(p => {
          const dept = formData.departs.find(d => String(d.cat_id) === String(p.test_cat));
          return dept && dept.cat_name && selIds.some(s => dept.cat_name.toLowerCase() === s.toLowerCase());
        });
        return matchesById || matchesByName;
      });
    }

    // ✅ Multi-test filter
    if (formData.selectedTests && formData.selectedTests.length > 0) {
      const selTests = formData.selectedTests.map(t => t.value.toLowerCase());
      filteredData = filteredData.filter(item => {
        const tests = item.tests || [];
        return tests.some(t =>
          selTests.some(st => (t.lab_item_test_name || t.test_name || '').toLowerCase().includes(st))
        );
      });
    }

    // ✅ Multi-user filter
    if (formData.selectedUserIds && formData.selectedUserIds.length > 0) {
      const selUids = formData.selectedUserIds.map(u => String(u.value));
      filteredData = filteredData.filter(item => {
        const uid = item.last_used_id ?? item.lab_reg_user ?? item.user_id ?? null;
        return selUids.includes(String(uid));
      });
    }

    // ✅ Apply multi test-department filter
    filteredData = filterByTestDepartment(filteredData, selectedTestDepts);

    return groupByUHID(filteredData);

  }, [
    masterList,
    formData.selectedDepartments,
    formData.selectedTests,
    formData.departs,
    formData.selectedUserIds,
    selectedTestDepts
  ]);
  
  const finalList = useMemo(() => {
    if (!formData.search_key || formData.search_key.trim() === "") return filteredList;
    const sk = formData.search_key.toLowerCase();
    return filteredList.filter(item =>
      (`${item.lab_reg_uhid || ''}`).toLowerCase().includes(sk) ||
      (`${item.lab_reg_name || ''}`).toLowerCase().includes(sk) ||
      (`${item.lab_reg_mobile || ''}`).toLowerCase().includes(sk)
    );
  }, [filteredList, formData.search_key]);

  const hasUnapprovedReports = useMemo(() => {
    return finalList.some(item => !approvalStatus[item.lab_reg_id]?.approved);
  }, [finalList, approvalStatus]);



  const categoryOptions = useMemo(() =>
    (categories || []).map(d => ({
      value: String(d.cat_id),
      label: d.cat_name || ''
    })),
    [categories]
  );
  // ✅ FIXED: totals calculation using filtered amounts
  useEffect(() => {
    const num = v => {
      const n = Number(v ?? 0);
      return Number.isFinite(n) ? n : 0;
    };

    if ((!finalList || finalList.length === 0) && 
        (!paymentsList || paymentsList.length === 0)) {
      setTotals({
        totalCharges: "0.00", finalAmount: "0.00", newPaid: "0.00",
        laterPaid: "0.00", totalPaid: "0.00", discountAmount: "0.00",
        totalDue: "0.00", totalRows: 0, cashTotal: "0.00",
        cardTotal: "0.00", onlineTotal: "0.00"
      });
      return;
    }

    const laterPaidByReg = {};
    let laterPaidTotal = 0;
    let laterCash = 0, laterCard = 0, laterOnline = 0;

    (paymentsList || []).forEach(p => {
      const regId = String(p.lab_reg_id ?? p.__sourceRow?.lab_reg_id ?? 'unknown');
      const amt = num(p.lab_due_pay_amount ?? 0);
      laterPaidTotal += amt;
      laterPaidByReg[regId] = (laterPaidByReg[regId] || 0) + amt;

      const mode = classifyMode(p.lab_due_pay_mode || p.__sourceRow?.lab_due_pay_mode || '');
      if (mode === 'cash') laterCash += amt;
      else if (mode === 'card') laterCard += amt;
      else if (mode === 'online') laterOnline += amt;
    });

    let totalCharges = 0, finalAmount = 0, groupPaidTotal = 0, discountAmount = 0;
    let cashTotal = 0, cardTotal = 0, onlineTotal = 0;

    (finalList || []).forEach(g => {
      const first = g.__firstRow || {};
      const groupFinal = num(g.total_final_amt ?? 0);
      const groupPaid = num(g.total_paid ?? 0);
      const testsTotal = (g.tests || []).reduce((sum, t) => sum + getTestPrice(t), 0);

      totalCharges += testsTotal;
      finalAmount += groupFinal;
      groupPaidTotal += groupPaid;

      const extractDiscount = (r) => {
        if (!r) return 0;
        if (r.lab_discount !== undefined && r.lab_discount !== null && r.lab_discount !== '') return num(r.lab_discount);
        if (r.lab_dis_amt !== undefined && r.lab_dis_amt !== null && r.lab_dis_amt !== '') return num(r.lab_dis_amt);
        if (r.lab_fix_deposit !== undefined && r.lab_fix_deposit !== null && r.lab_fix_deposit !== '') return num(r.lab_fix_deposit);
        if (r.lab_dis_per !== undefined && r.lab_dis_per !== null && r.lab_dis_per !== '') {
          return (testsTotal * num(r.lab_dis_per)) / 100;
        }
        return 0;
      };
      discountAmount += extractDiscount(g) || extractDiscount(first);

      cashTotal += num(g.cash_amount ?? 0);
      cardTotal += num(g.card_amount ?? 0);
      onlineTotal += num(g.online_amount ?? 0);
    });

    let computedTotalDue = 0;
    (finalList || []).forEach(g => {
      const first = g.__firstRow || {};
      const regId = String(g.lab_reg_id ?? first.lab_reg_id ?? '');
      const groupFinal = num(g.total_final_amt ?? 0);
      const groupPaid = num(g.total_paid ?? 0);
      const laterForThis = num(laterPaidByReg[regId] || 0);
      let dueForReg = groupFinal - (groupPaid + laterForThis);
      if (!Number.isFinite(dueForReg) || dueForReg < 0) dueForReg = 0;
      computedTotalDue += dueForReg;
    });

    cashTotal += laterCash;
    cardTotal += laterCard;
    onlineTotal += laterOnline;
    const totalPaid = groupPaidTotal + laterPaidTotal;

    setTotals({
      totalCharges: totalCharges.toFixed(2),
      finalAmount: finalAmount.toFixed(2),
      newPaid: groupPaidTotal.toFixed(2),
      laterPaid: laterPaidTotal.toFixed(2),
      totalPaid: totalPaid.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      totalDue: computedTotalDue.toFixed(2),
      totalRows: (finalList || []).length,
      cashTotal: cashTotal.toFixed(2),
      cardTotal: cardTotal.toFixed(2),
      onlineTotal: onlineTotal.toFixed(2)
    });

  }, [finalList, paymentsList]);

  const columns = useMemo(() => [
    { name: '#', selector: (row, i) => i + 1, width: '60px' },
    { name: 'UHID', selector: row => row.lab_reg_uhid || '', sortable: true, width: '160px' },
    {
      name: 'Patient',
      selector: row => `${row.lab_reg_name_title || ''} ${row.lab_reg_name || ''}`,
      sortable: true,
      cell: row => (<div>{row.lab_reg_name_title} {row.lab_reg_name}<br/><small>{row.lab_reg_mobile}</small></div>),
      wrap: true,
      width: '200px'
    },
    {
      name: 'Tests',
      selector: row => row.tests?.map(t => t.lab_item_test_name).join(', '),
      wrap: true,
      grow: 2,
      cell: row => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.4" }}>
          {(row.tests || []).map((t, i) => (
            <div key={i}>
              • {t.lab_item_test_name} 
              <span className="text-muted ms-2">
                (₹{getTestPrice(t).toFixed(2)})
              </span>
            </div>
          ))}
          {row.tests && row.tests.length > 1 && (
            <div className="mt-1 pt-1 border-top">
              <strong>Tests Total: ₹{Number(row.total_final_amt || 0).toFixed(2)}</strong>
            </div>
          )}
        </div>
      ),
      width: '300px'
    },
    { name: 'Referral/Doctor', selector: row => (row.lab_reg_referral || row.fname || row.last_used || ''), width: '220px' },
    { name: 'Total', selector: row => Number(row.total_final_amt || 0).toFixed(2), sortable: true, right: true },
    { name: 'Paid', selector: row => Number(row.total_paid || row.lab_paid || 0).toFixed(2), sortable: true, right: true },
    { name: 'Due', selector: row => Number(row.total_due || row.lab_due || 0).toFixed(2), sortable: true, right: true },
    { name: 'Cash', selector: row => Number(row.cash_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },
    { name: 'Card', selector: row => Number(row.card_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },
    { name: 'Online', selector: row => Number(row.online_amount || 0).toFixed(2), sortable: true, right: true, width: '110px' },
    { name: 'Payment Type', selector: row => mapPayMode(row.__firstRow?.lab_pay_mode || row.lab_pay_mode || ''), width: '140px' },
    {
      name: 'User',
      selector: row => (row.last_used || row.fname || row.lab_reg_user || '').toString(),
      width: '160px',
      cell: row => {
        const uid = row.last_used_id ?? row.lab_reg_user ?? row.__firstRow?.user_id ?? '';
        const uname = (row.last_used && row.last_used.trim()) || (row.fname && row.fname.trim()) || (row.__firstRow && (row.__firstRow.fname || row.__firstRow.username)) || `User #${uid}`;
        return <div>{uname}<br/></div>;
      }
    },
    {
      name: 'Date',
      selector: row => {
        const dt = parseServerDate(row.lab_reg_datetime || row.__firstRow?.lab_reg_datetime || '');
        return dt ? dt.getTime() : 0;
      },
      sortable: true,
      cell: row => {
        const dt = parseServerDate(row.lab_reg_datetime || row.__firstRow?.lab_reg_datetime || '');
        return dt ? formatDateTime12h(dt) : '';
      },
      width: '230px'
    }
  ], []);

  const paymentColumns = useMemo(() => [
    { name: '#', selector: (row, i) => i + 1, width: '60px' },
    { name: 'UHID', selector: row => row.lab_reg_uhid || '', sortable: true },
    { name: 'Name', selector: row => row.lab_reg_name || '' },
    { name: 'Payment Mode', selector: row => mapPayMode(row.lab_due_pay_mode), width: '120px' },
    {
      name: 'Date',
      selector: row => {
        const dt = parseServerDate(row.lab_due_pay_date || '');
        return dt ? dt.getTime() : 0;
      },
      sortable: true,
      cell: row => {
        const dt = parseServerDate(row.lab_due_pay_date || '');
        return dt ? formatDateTime12h(dt) : '';
      },
      width: '170px'
    },
    { name: 'Amount', selector: row => Number(row.lab_due_pay_amount || 0).toFixed(2), right: true },
    {
      name: 'User',
      selector: row => row.lab_due_pay_user_name || row.lab_due_pay_user || '',
      width: '180px',
      cell: row => (
        <div>{row.lab_due_pay_user_name || row.lab_due_pay_user || ''}</div>
      )
    }
  ], []);

  const getUHIDFromRegId = (regId) => {
    if (!regId) return '';
    const record = masterList.find(r => String(r.lab_reg_id) === String(regId));
    return record?.lab_reg_uhid || '';
  };

  const transactionColumns = useMemo(() => [
    { name: '#', selector: (row, i) => i + 1, width: '60px' },
    { name: 'Reg ID', selector: row => row.payment_lab_reg_id || '', sortable: true, width: '100px' },
    { name: 'UHID', selector: row => getUHIDFromRegId(row.payment_lab_reg_id), sortable: true, width: '140px' },
    { name: 'Amount', selector: row => Number(row.payment_amount || 0).toFixed(2), right: true, width: '100px' },
    { name: 'Mode', selector: row => mapPayMode(row.payment_mode), width: '100px' },
    { name: 'Received By', selector: row => row.payment_received_by || '', width: '150px' },
    {
      name: 'Date',
      selector: row => {
        const dt = parseServerDate(row.payment_datetime || '');
        return dt ? dt.getTime() : 0;
      },
      sortable: true,
      cell: row => {
        const dt = parseServerDate(row.payment_datetime || '');
        return dt ? formatDateTime12h(dt) : '';
      },
      width: '200px'
    },
    { name: 'Remarks', selector: row => row.payment_remarks || '', wrap: true, width: '200px' }
  ], [masterList]);

  const handleClear = () => {
    setFormData(prev => ({
      ...prev,
      search_key: "",
      from: localToday,
      to: localToday,
      lab_reg_referral_user_ids: [],
      lab_reg_referral: "",
      selectedDepartments: [],
      selectedTests: [],
      selectedUserIds: []
    }));
    setSelectedTestDepts([]);
    setTimeout(() => initData(), 60);
  };

  const exportPdf = () => {
    try {
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      const leftMargin = 36;
      let cursorY = 40;

      doc.setFontSize(16);
      doc.text('Lab Reports', leftMargin, cursorY);
      cursorY += 18;
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleString()}`, leftMargin, cursorY);
      cursorY += 18;

      const regs = finalList || [];
      const regHead = ['#', 'UHID', 'Patient', 'User', 'Total', 'Paid', 'Due', 'Date'];
      const regBody = regs.map((r, i) => {
        const userDisplay = (r.last_used && r.last_used.trim()) || (r.fname && r.fname.trim()) || '';
        const dt = parseServerDate(r.lab_reg_datetime || r.__firstRow?.lab_reg_datetime || '');
        const dateStr = dt ? formatDateTime12h(dt) : '';
        return [
          i + 1,
          r.lab_reg_uhid || '',
          `${r.lab_reg_name_title || ''} ${r.lab_reg_name || ''}`.trim(),
          userDisplay,
          Number(r.total_final_amt || 0).toFixed(2),
          Number(r.total_paid || r.lab_paid || 0).toFixed(2),
          Number(r.total_due || r.lab_due || 0).toFixed(2),
          dateStr
        ];
      });

      if (regBody.length === 0) regBody.push(['', '', 'No records', '', '', '', '', '']);

      autoTable(doc, {
        startY: cursorY, head: [regHead], body: regBody,
        styles: { fontSize: 9 }, headStyles: { fillColor: [0, 0, 139] },
        margin: { left: leftMargin, right: leftMargin }, theme: 'grid',
      });

      cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 18 : cursorY + 200;
      doc.setFontSize(13);
      doc.text('Payments on Reports (Due Payments)', leftMargin, cursorY);
      cursorY += 12;

      const pays = paymentsList || [];
      const payHead = ['#', 'UHID', 'Name', 'Mode', 'Date', 'Amount', 'User'];
      const payBody = pays.map((p, i) => {
        const dt = parseServerDate(p.lab_due_pay_date || '');
        return [
          i + 1, p.lab_reg_uhid || '', p.lab_reg_name || '',
          mapPayMode(p.lab_due_pay_mode), dt ? formatDateTime12h(dt) : '',
          Number(p.lab_due_pay_amount || 0).toFixed(2),
          p.lab_due_pay_user_name || p.lab_due_pay_user || ''
        ];
      });
      if (payBody.length === 0) payBody.push(['', '', 'No payments', '', '', '', '']);

      autoTable(doc, {
        startY: cursorY, head: [payHead], body: payBody,
        styles: { fontSize: 9 }, headStyles: { fillColor: [0, 0, 139] },
        margin: { left: leftMargin, right: leftMargin }, theme: 'grid',
      });

      cursorY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 18 : cursorY + 200;
      doc.setFontSize(13);
      doc.text('Payment Transactions', leftMargin, cursorY);
      cursorY += 12;

      const txns = paymentTransactions || [];
      const txnHead = ['#', 'Reg ID', 'UHID', 'Amount', 'Mode', 'Received By', 'Date', 'Remarks'];
      const txnBody = txns.map((t, i) => {
        const dt = parseServerDate(t.payment_datetime || '');
        return [
          i + 1, t.payment_lab_reg_id || '', getUHIDFromRegId(t.payment_lab_reg_id),
          Number(t.payment_amount || 0).toFixed(2), mapPayMode(t.payment_mode),
          t.payment_received_by || '', dt ? formatDateTime12h(dt) : '', t.payment_remarks || ''
        ];
      });
      if (txnBody.length === 0) txnBody.push(['', '', '', 'No transactions', '', '', '', '']);

      autoTable(doc, {
        startY: cursorY, head: [txnHead], body: txnBody,
        styles: { fontSize: 9 }, headStyles: { fillColor: [0, 0, 139] },
        margin: { left: leftMargin, right: leftMargin }, theme: 'grid',
      });

      doc.save(`lab-reports-${(new Date()).toISOString().slice(0,10)}.pdf`);
    } catch (err) {
      console.error("exportPdf error:", err);
      toast.error("Failed to export PDF - see console.");
    }
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '55px'
      }
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Summary cards */}
        <div className="row mb-3">
          <div className="col-md-6">
            <div className="card p-3">
              <p className="mb-1 text-muted">
                <div
                  className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 50, height: 50 }}
                >
                  <i className="bi bi-file-earmark-bar-graph-fill" style={{ fontSize: 26, color: "#198754" }}></i>
                </div>
                Total Reports
              </p>
              <h4 className="mb-0" style={{ color: "#14532d" }}>{summary.totalReports}</h4>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card p-3">
              <p className="mb-1 text-muted">
                <div
                  className="bg-light-success rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{ width: 50, height: 50 }}
                >
                  <i className="bi bi-currency-rupee" style={{ fontSize: 26, color: "#198754" }} />
                </div>
                Total Amount
              </p>
              <h4 className="mb-0" style={{ color: "#14532d" }}>{summary.totalAmount}</h4>
            </div>
          </div>
        </div>

        {/* Payment Mode Summary Card */}
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="card p-3">
              <h5 className="mb-3">Payment Mode Summary (All Payments)</h5>
              <div className="row">
                <div className="col-md-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 50, height: 50 }}>
                      <i className="bi bi-cash-stack" style={{ fontSize: 24, color: "#198754" }}></i>
                    </div>
                    <div>
                      <p className="mb-0 text-muted">Cash</p>
                      <h5 className="mb-0">₹ {totals.cashTotal}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 50, height: 50 }}>
                      <i className="bi bi-credit-card" style={{ fontSize: 24, color: "#0d6efd" }}></i>
                    </div>
                    <div>
                      <p className="mb-0 text-muted">Card</p>
                      <h5 className="mb-0">₹ {totals.cardTotal}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 50, height: 50 }}>
                      <i className="bi bi-phone" style={{ fontSize: 24, color: "#0dcaf0" }}></i>
                    </div>
                    <div>
                      <p className="mb-0 text-muted">Online</p>
                      <h5 className="mb-0">₹ {totals.onlineTotal}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="d-flex align-items-center">
                    <div className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 50, height: 50 }}>
                      <i className="bi bi-wallet2" style={{ fontSize: 24, color: "#ffc107" }}></i>
                    </div>
                    <div>
                      <p className="mb-0 text-muted">Total Paid</p>
                      <h5 className="mb-0">₹ {totals.totalPaid}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ════════════════════════════════════════════════════════════
            FILTERS — now using react-select multiselect
            ════════════════════════════════════════════════════════════ */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-3">
                <label>Search</label>
                <input className="form-control" name="search_key" value={formData.search_key} onChange={handleChange} placeholder="UHID / Name / Mobile"/>
              </div>
              <div className="col-md-2">
                <label>From</label>
                <input className="form-control" type="date" name="from" value={formData.from} onChange={handleChange}/>
              </div>
              <div className="col-md-2">
                <label>To</label>
                <input className="form-control" type="date" name="to" value={formData.to} onChange={handleChange}/>
              </div>

              {/* ✅ Doctor — multiselect */}
              <div className="col-md-3">
                <label>Doctor</label>
                <Select
                  isMulti
                  options={doctorOptions}
                  value={doctorOptions.filter(o =>
                    (formData.lab_reg_referral_user_ids || []).includes(o.value)
                  )}
                  onChange={(selected) => {
                    const ids = (selected || []).map(s => s.value);
                    setFormData(prev => ({
                      ...prev,
                      lab_reg_referral_user_ids: ids,
                      lab_reg_referral: (selected || []).map(s => s.label).join(', ')
                    }));
                  }}
                  placeholder="All Doctors"
                  isClearable
                  styles={reactSelectStyles}
                  closeMenuOnSelect={false}
                />
              </div>

              <div className="col-md-2 d-flex align-items-end">
                <button className="btn btn-success me-2" onClick={() => initData()}>Search</button>
                <button className="btn btn-secondary" onClick={handleClear}>Clear</button>
              </div>
            </div>

            {/* Second row of filters */}
            <div className="row g-2 mt-3">

              {/* ✅ Test Department — multiselect */}
              <div className="col-md-3">
                <label>Test Department</label>
                <Select
                  isMulti
                  options={testDeptOptions}
                  value={selectedTestDepts}
                  onChange={(selected) => {
                    setSelectedTestDepts(selected || []);
                    // Reset test selection when departments change
                    setFormData(prev => ({ ...prev, selectedTests: [] }));
                  }}
                  placeholder="All Test Departments"
                  isClearable
                  styles={reactSelectStyles}
                  closeMenuOnSelect={false}
                />
              </div>
{/* ✅ Category (Department) — multiselect */}
<div className="col-md-3">
  <label>Test Category</label>
  <Select
    isMulti
    options={categoryOptions}
    value={formData.selectedDepartments}
    onChange={(selected) => {
      setFormData(prev => ({ ...prev, selectedDepartments: selected || [] }));
    }}
    placeholder="All Categories"
    isClearable
    styles={reactSelectStyles}
    closeMenuOnSelect={false}
  />
</div>



              {/* ✅ Test — multiselect */}
              <div className="col-md-3">
                <label>Test</label>
                <Select
                  isMulti
                  options={testOptions}
                  value={(formData.selectedTests || []).map(t =>
                    typeof t === 'string' ? { value: t, label: t } : t
                  )}
                  onChange={(selected) => {
                    setFormData(prev => ({
                      ...prev,
                      selectedTests: selected || []
                    }));
                  }}
                  placeholder="All Tests"
                  isClearable
                  styles={reactSelectStyles}
                  closeMenuOnSelect={false}
                />
              </div>

              {/* ✅ User — multiselect */}
              <div className="col-md-3">
                <label>User</label>
                <Select
                  isMulti
                  options={userOptions}
                  value={userOptions.filter(o =>
                    (formData.selectedUserIds || []).map(String).includes(o.value)
                  )}
                  onChange={(selected) => {
                    const ids = (selected || []).map(s => s.value);
                    setFormData(prev => ({ ...prev, selectedUserIds: ids }));
                  }}
                  placeholder="All Users"
                  isClearable
                  styles={reactSelectStyles}
                  closeMenuOnSelect={false}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Table + PDF export */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <div />
              <div>
                <button className="btn btn-warning" onClick={exportPdf}>Export PDF</button>
              </div>
            </div>

            <DataTable
              columns={columns}
              data={finalList}
              customStyles={customStyles}
              pagination
              highlightOnHover
              dense
              persistTableHead
              responsive
            />

            {/* Total Test Amount Summary Card */}
            <div className="row mt-4 mb-3">
              <div className="col-md-12">
                <div className="card p-3" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #198754' }}>
                  <div className="row align-items-center">
                    <div className="col-md-3">
                      <div className="d-flex align-items-center">
                        <div className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 60, height: 60 }}>
                          <i className="bi bi-calculator" style={{ fontSize: 28, color: "#198754" }}></i>
                        </div>
                        <div>
                          <p className="mb-0 text-muted">Total Test Amount</p>
                          <h3 className="mb-0" style={{ color: "#198754" }}>₹ {totals.finalAmount}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <p className="mb-0 text-muted">Total Patients</p>
                        <h4 className="mb-0">{totals.totalRows}</h4>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <p className="mb-0 text-muted">Total Paid</p>
                        <h4 className="mb-0 text-success">₹ {totals.totalPaid}</h4>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="text-center">
                        <p className="mb-0 text-muted">Total Due</p>
                        <h4 className="mb-0 text-danger">₹ {totals.totalDue}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h5 className="mt-4">Payments on Reports (Due Payments)</h5>
            <DataTable
              columns={paymentColumns}
              data={paymentsList}
              customStyles={customStyles}
              pagination
              highlightOnHover
              dense
              persistTableHead
              responsive
            />

            <h5 className="mt-4">Payment Transactions (from lab_payment_transactions)</h5>
            <DataTable
              columns={transactionColumns}
              data={paymentTransactions}
              customStyles={customStyles}
              pagination
              highlightOnHover
              dense
              persistTableHead
              responsive
            />

            <div className="d-flex justify-content-end mt-3">
              <div className="text-muted" style={{ fontSize: '0.95rem' }}>
                <strong>Total (Charges):</strong> {totals.totalCharges} &nbsp;|&nbsp;
                <strong>Final Amount (Payable):</strong> {totals.finalAmount} &nbsp;|&nbsp;
                <strong>New Paid:</strong> {totals.newPaid} &nbsp;|&nbsp;
                <strong>Later Paid:</strong> {totals.laterPaid} &nbsp;|&nbsp;
                <strong>Total Paid (All):</strong> {totals.totalPaid} &nbsp;|&nbsp;
                <strong>Discount:</strong> {totals.discountAmount} &nbsp;|&nbsp;
                <strong>Total Due:</strong> {totals.totalDue} &nbsp;|&nbsp;
                <strong>Cash (paid):</strong> {totals.cashTotal} &nbsp;|&nbsp;
                <strong>Card (paid):</strong> {totals.cardTotal} &nbsp;|&nbsp;
                <strong>Online (paid):</strong> {totals.onlineTotal}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default LabReports;